const previewConstants = {
  TOKENKEY: "token",
};

export default previewConstants;
